import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);

export function formatDateTime(datetime) {
  if (!datetime) return "N/D";
  try {
    return dayjs(datetime).format("DD-MM-YYYY - HH:mm");
  } catch (error) {
    return "Date invalide";
  }
}

export function toUtcIsoDateTime(dateInput, hour, minute) {
  if (!dateInput || isNaN(hour) || isNaN(minute)) return null;

  const dateStr =
    typeof dateInput === "string"
      ? dateInput
      : dateInput.toISOString().split("T")[0];

  const paddedHour = hour.toString().padStart(2, "0");
  const paddedMinute = minute.toString().padStart(2, "0");

  const localDateTime = dayjs(
    `${dateStr} ${paddedHour}:${paddedMinute}`,
    "YYYY-MM-DD HH:mm"
  );

  if (!localDateTime.isValid()) return null;

  // Return UTC ISO string
  return localDateTime.utc().toISOString();
}
